<template>
    <div>
        <p :class="pClass">
            {{ showLabel }} <span>{{ startRange }}</span><span v-if="separator === '-'">-</span><span v-else> to </span><span>{{ endRange }}</span> {{ ofLabel }} <span>{{ totalResults }}</span> {{ noun }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        pClass: {
            type: String,
            default: 'text-slate-600 text-sm font-medium leading-tight',
        },
        startRange: {
            type: Number,
            required: true,
        },
        endRange: {
            type: Number,
            required: true,
        },
        totalResults: {
            type: Number,
            required: true,
        },
        noun: {
            type: String,
            default: 'results',
        },
        separator: {
            type: String,
            default: 'to', // 'to' or '-'
            validator: (val) => ['to', '-'].includes(val),
        },
        showLabel: {
            type: String,
            default: 'Showing',
        },
        ofLabel: {
            type: String,
            default: 'of',
        },
    },
};
</script>
